import { z } from 'zod';

// === Stock Inventory Schema ===
// Matches chemical_frontend and fertilzer_frontend DB tables

export const StockItemSchema = z.object({
  id: z.number(),
  company_id: z.union([z.string(), z.number()]),
  // chemical_frontend uses 'product', fertilzer_frontend uses 'fertilzer'
  product: z.string().nullable().optional(),
  fertilzer: z.string().nullable().optional(),
  category: z.number().nullable().optional(),
  withholding: z.number().nullable().optional(),
  cost: z.number().nullable().optional(),
  pack_size_litres_kg: z.string().nullable().optional(),
  minimum_stock_holding: z.number().nullable().optional(),
  stock_level: z.number().nullable().optional(),
  stock_litres_kgs: z.number().nullable().optional(),
  reserved_stock: z.number().nullable().optional(),
  safety_data_sheets: z.number().nullable().optional(),
  safety_data_sheet_link: z.string().nullable().optional(),
  fertilzer_company: z.number().nullable().optional(),
  created_by: z.string().nullable().optional(),
  updated_by: z.string().nullable().optional(),
  created_at: z.string(),
  updated_at: z.string(),
  deleted_at: z.string().nullable().optional(),
});

export type StockItem = z.infer<typeof StockItemSchema>;

export const StockItemInsertSchema = StockItemSchema.omit({
  id: true,
  created_at: true,
  updated_at: true,
});
export type StockItemInsert = z.infer<typeof StockItemInsertSchema>;

export const StockItemUpdateSchema = StockItemSchema.partial().required({ id: true });
export type StockItemUpdate = z.infer<typeof StockItemUpdateSchema>;
